import { createActionCreator } from 'deox'
import { IDrop } from '../../types/reducerTypes'

export const addAllListDrops = createActionCreator(
  'ADD_ALL_DROPS',
  (resolve) => (drops: IDrop[], total: number) => resolve({ drops, total }),
)

export const setAllDropsStatusLoading = createActionCreator(
  'SET_ALL_DROPS_STATUS_LOADING',
  (resolve) => (loading: boolean) => resolve({ loading }),
)

export const addUpcomingListDrops = createActionCreator(
  'ADD_UPCOMING_DROPS',
  (resolve) => (drops: IDrop[]) => resolve({ drops }),
)

export const addActiveListDrops = createActionCreator(
  'ADD_ACTIVE_DROPS',
  (resolve) => (drops: IDrop[]) => resolve({ drops }),
)

export const addCompletedListDrops = createActionCreator(
  'ADD_COMPLETED_DROPS',
  (resolve) => (drops: IDrop[]) => resolve({ drops }),
)

export const addMostTractionListDrops = createActionCreator(
  'ADD_MOST_TRACTION_DROPS',
  (resolve) => (drops: IDrop[]) => resolve({ drops }),
)

export const addRecentlyLaunchedListDrops = createActionCreator(
  'ADD_RECENTLY_LAUNCHED_DROPS',
  (resolve) => (drops: IDrop[]) => resolve({ drops }),
)

export const addClosingSoonListDrops = createActionCreator(
  'ADD_CLOSING_SOON_DROPS',
  (resolve) => (drops: IDrop[]) => resolve({ drops }),
)

export const addMostFundedListDrops = createActionCreator(
  'ADD_MOST_FUNDED_DROPS',
  (resolve) => (drops: IDrop[]) => resolve({ drops }),
)

export const setStatusLoading = createActionCreator(
  'SET_STATUS_LOADING',
  (resolve) => (loading: boolean) => resolve({ loading }),
)
